// client/src/hooks/useEntregaConfig.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const QUERY_KEY = 'entregaConfig';

const invalidateCache = (queryClient) => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
};

export const useEntregaConfigs = (params = {}) => {
    return useQuery({
        queryKey: [QUERY_KEY, params],
        queryFn: async () => {
            const { data } = await apiClient.get('/entrega-config', { params });
            return data;
        },
        staleTime: 5 * 60 * 1000,
    });
};

export const useMutateEntregaConfig = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    const createConfig = useMutation({
        mutationFn: (newData) => apiClient.post('/entrega-config', newData),
        onSuccess: () => {
            invalidateCache(queryClient);
            setAlert('Configuração de entrega criada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao criar configuração de entrega', 'danger'),
    });

    const updateConfig = useMutation({
        mutationFn: ({ id, updatedData }) => apiClient.put(`/entrega-config/${id}`, updatedData),
        onSuccess: () => {
            invalidateCache(queryClient);
            setAlert('Configuração atualizada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao atualizar configuração', 'danger'),
    });

    const deleteConfig = useMutation({
        mutationFn: (id) => apiClient.delete(`/entrega-config/${id}`),
        onSuccess: () => {
            invalidateCache(queryClient);
            setAlert('Configuração removida com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || 'Erro ao remover configuração', 'danger'),
    });

    return { createConfig, updateConfig, deleteConfig };
};
